import { render, staticRenderFns } from "./stamping.vue?vue&type=template&id=62e9cf26&"
import script from "./stamping.vue?vue&type=script&lang=js&"
export * from "./stamping.vue?vue&type=script&lang=js&"
import style0 from "./stamping.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports